import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { MarketTicker } from '../components/MarketTicker';
import { AdPlaceholder } from '../components/AdPlaceholder';
import { SidebarMarketWidget } from '../components/SidebarMarketWidget';
import { Facebook, Twitter, Linkedin, Mail, Printer } from 'lucide-react';
export function Article() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 flex flex-col" data-id="element-288">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-289">
        <Header data-id="element-290" />
        <Navigation data-id="element-291" />
      </div>

      <MarketTicker data-id="element-292" />

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-293">
        {/* Banner Ad */}
        <div className="py-6 flex justify-center" data-id="element-294">
          <AdPlaceholder width="w-full max-w-[728px]" height="h-[90px]" text="Advertisement" data-id="element-295" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-296">
          {/* LEFT COLUMN: Article Content */}
          <main className="lg:col-span-8" data-id="element-297">
            <h1 className="font-serif text-4xl md:text-[2.75rem] leading-tight text-gray-900 mb-6" data-id="element-298">
              Perdue Foods appoints Andy Urban as chief commercial officer
            </h1>

            <div className="mb-6" data-id="element-299">
              <img src="https://placehold.co/800x450/e2e8f0/475569?text=Andy+Urban" alt="Andy Urban" className="w-full h-auto object-cover" data-id="element-300" />
              <p className="text-sm text-gray-600 italic text-center mt-2" data-id="element-301">
                Andy Urban, chief commercial officer, Perdue Foods | Source:
                Perdue Foods
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-between border-b border-gray-200 pb-4 mb-6 gap-4" data-id="element-302">
              <div className="text-sm text-gray-600" data-id="element-303">
                04.08.2026 <span className="mx-2" data-id="element-304">|</span> By{' '}
                <a href="#" className="text-[#002f5f] hover:underline font-medium" data-id="element-305">
                  Rachael Oatman
                </a>
              </div>

              <div className="flex items-center gap-2" data-id="element-306">
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors" data-id="element-307">
                  <Facebook className="w-4 h-4 fill-current" data-id="element-308" />
                </button>
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors" data-id="element-309">
                  <Twitter className="w-4 h-4 fill-current" data-id="element-310" />
                </button>
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors text-xs font-bold" data-id="element-311">
                  in
                </button>
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors" data-id="element-312">
                  <Mail className="w-4 h-4" data-id="element-313" />
                </button>
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors" data-id="element-314">
                  <Printer className="w-4 h-4" data-id="element-315" />
                </button>
              </div>
            </div>

            <div className="prose prose-lg max-w-none text-gray-800 leading-relaxed space-y-6" data-id="element-316">
              <p data-id="element-317">
                SALISBURY, MD. — Perdue Foods appointed Andy Urban as chief
                commercial officer, effective immediately. In this role, he will
                lead the company's commercial organization to drive growth and
                strengthen customer partnerships, overseeing sales, marketing,
                customer development, revenue management and innovation.
              </p>
              <p data-id="element-318">
                "Andy is a proven commercial leader with a deep understanding of
                our business, our customers and consumers, and our culture,"
                said Kevin McAdams, president and chief executive officer of
                Perdue Farms. "His track record of driving growth, building
                high-performing teams and delivering results makes him
                exceptionally well-suited to lead our commercial organization as
                we continue to evolve and compete in a dynamic marketplace."
              </p>
              <p data-id="element-319">
                With more than 35 years of experience, Urban is seasoned in
                leading complex, multi-channel consumer packaged goods
                businesses, with deep expertise across retail, foodservice,
                club, mass, convenience, industrial and international markets.
              </p>
              <p data-id="element-320">
                Since joining Perdue in 2009, Urban has held a series of senior
                leadership roles spanning sales, general management and
                enterprise transformation. Most recently, he served as senior
                vice president of the transformation office, where he led
                initiatives to simplify company operation and improve execution.
                Previously, Urban served as senior vice president and general
                manager of Perdue Premium Meat Co., as well as senior vice
                president and general manager of the prepared foods and turkey
                businesses, where he led multi-billion-dollar portfolios with
                full profit and loss responsibility. Earlier in his career,
                Urban held senior sales leadership roles at Perdue, including
                leading retail sales across all major channels. Before joining
                the company, he worked at WhiteWave Foods and Con Agra Foods.
              </p>
              <p data-id="element-321">
                "I'm honored to step into this role at a pivotal time for
                Perdue," Urban said. "This company has a strong foundation, a
                powerful purpose and an incredible team. I look forward to
                working closely with our customers and associates to drive
                sustainable growth and deliver value across the business."
              </p>
            </div>

            <div className="flex flex-wrap gap-2 mt-10 mb-8" data-id="element-322">
              <a href="#" className="px-3 py-1 border border-gray-300 text-xs font-medium text-[#002f5f] uppercase hover:bg-gray-50 transition-colors" data-id="element-323">
                Companies
              </a>
              <a href="#" className="px-3 py-1 border border-gray-300 text-xs font-medium text-[#002f5f] uppercase hover:bg-gray-50 transition-colors" data-id="element-324">
                Perdue Farms
              </a>
              <a href="#" className="px-3 py-1 border border-gray-300 text-xs font-medium text-[#002f5f] uppercase hover:bg-gray-50 transition-colors" data-id="element-325">
                People
              </a>
            </div>

            <hr className="border-gray-200 mb-8" data-id="element-326" />

            {/* Related Articles */}
            <div data-id="element-327">
              <div className="w-16 h-1 bg-[#38bdf8] mb-4" data-id="element-328"></div>
              <h3 className="text-2xl font-serif text-gray-900 mb-6" data-id="element-329">
                Related Articles
              </h3>
              <ul className="space-y-4" data-id="element-330">
                <li data-id="element-331">
                  <a href="#" className="text-[#002f5f] hover:underline text-lg" data-id="element-332">
                    Pilgrim's Europe appoints Matt Lee as chief business officer
                  </a>
                </li>
                <li data-id="element-333">
                  <a href="#" className="text-[#002f5f] hover:underline text-lg" data-id="element-334">
                    Foster Farms appoints new chief commercial officer
                  </a>
                </li>
                <li data-id="element-335">
                  <a href="#" className="text-[#002f5f] hover:underline text-lg" data-id="element-336">
                    Perdue Farms hires chief commercial officer
                  </a>
                </li>
              </ul>
            </div>
          </main>

          {/* RIGHT COLUMN: Sidebar */}
          <aside className="lg:col-span-4 flex flex-col gap-8" data-id="element-337">
            <AdPlaceholder width="w-full" height="h-[250px]" text="Advertisement (300x250)" data-id="element-338" />

            {/* Subscribe Box */}
            <div className="bg-gray-100 border border-gray-200 p-6 text-center" data-id="element-339">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-340">
                Subscribe Today
              </h3>
              <p className="text-sm text-gray-700 mb-6" data-id="element-341">
                Get your FREE subscription to <em data-id="element-342">Meat+Poultry</em> for the
                latest coverage of ingredients, equipment, food safety, and
                more.
              </p>
              <button className="bg-[#38bdf8] text-white px-6 py-2 rounded font-semibold hover:bg-sky-500 transition-colors w-full max-w-[200px]" data-id="element-343">
                Subscribe
              </button>
            </div>

            <AdPlaceholder width="w-full" height="h-[250px]" text="Advertisement (300x250)" data-id="element-344" />

            <SidebarMarketWidget data-id="element-345" />

            {/* Popular Articles */}
            <div data-id="element-346">
              <div className="flex items-center gap-4 mb-6" data-id="element-347">
                <h3 className="text-sm font-medium text-[#e8734a] uppercase tracking-wider whitespace-nowrap" data-id="element-348">
                  Popular Articles
                </h3>
                <div className="h-px bg-gray-300 w-full" data-id="element-349"></div>
              </div>
              <ul className="space-y-5" data-id="element-350">
                <li data-id="element-351">
                  <a href="#" className="text-gray-900 hover:text-[#002f5f] font-serif text-lg leading-snug transition-colors" data-id="element-352">
                    Triumph Foods readies for $30 million expansion in Missouri
                  </a>
                </li>
                <li data-id="element-353">
                  <a href="#" className="text-gray-900 hover:text-[#002f5f] font-serif text-lg leading-snug transition-colors" data-id="element-354">
                    Chicken nuggets subject of public health alert over possible
                    lead contamination
                  </a>
                </li>
                <li data-id="element-355">
                  <a href="#" className="text-gray-900 hover:text-[#002f5f] font-serif text-lg leading-snug transition-colors" data-id="element-356">
                    Tyson Foods closing Georgia prepared foods plant
                  </a>
                </li>
                <li data-id="element-357">
                  <a href="#" className="text-gray-900 hover:text-[#002f5f] font-serif text-lg leading-snug transition-colors" data-id="element-358">
                    Hertzog Meat Co. expands with new Butler processing plant
                  </a>
                </li>
              </ul>
            </div>

            {/* Popular Galleries */}
            <div data-id="element-359">
              <div className="flex items-center gap-4 mb-6" data-id="element-360">
                <h3 className="text-sm font-medium text-[#e8734a] uppercase tracking-wider whitespace-nowrap" data-id="element-361">
                  Popular Galleries
                </h3>
                <div className="h-px bg-gray-300 w-full" data-id="element-362"></div>
              </div>
              <div className="space-y-6" data-id="element-363">
                <div className="flex gap-4 group cursor-pointer" data-id="element-364">
                  <img src="https://placehold.co/120x80/e2e8f0/475569?text=MLB" alt="MLB" className="w-24 h-16 object-cover flex-shrink-0" data-id="element-365" />
                  <div data-id="element-366">
                    <h4 className="font-serif text-[1.1rem] leading-tight text-gray-900 group-hover:text-[#002f5f] transition-colors mb-1" data-id="element-367">
                      MLB menu innovation hits a grand slam
                    </h4>
                    <p className="text-xs text-gray-600 line-clamp-2" data-id="element-368">
                      New items include locally-inspired dishes and global
                      cuisine.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4 group cursor-pointer" data-id="element-369">
                  <img src="https://placehold.co/120x80/e2e8f0/475569?text=Bacon" alt="Bacon" className="w-24 h-16 object-cover flex-shrink-0" data-id="element-370" />
                  <div data-id="element-371">
                    <h4 className="font-serif text-[1.1rem] leading-tight text-gray-900 group-hover:text-[#002f5f] transition-colors mb-1" data-id="element-372">
                      Bacon formulations
                    </h4>
                    <p className="text-xs text-gray-600 line-clamp-2" data-id="element-373">
                      Snapshots of new belly-centric pork products.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>;
}